import { render, staticRenderFns } from "./CarouselSlider.vue?vue&type=template&id=395d47e5&"
import script from "./CarouselSlider.vue?vue&type=script&lang=js&"
export * from "./CarouselSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports